// extracted by mini-css-extract-plugin
export default {"actionBtn":"styles_actionBtn__3sIpO","actionIcon":"styles_actionIcon__rGO2I"};